import { Injectable } from '@angular/core';
import {BaseModel} from "./definitions/base-model";

@Injectable({
  providedIn: 'root'
})
export class CrudService {

  constructor() {

  }

  getDestroyFieldName() {
    return 'destroy';
  }

  setDestroy(obj: any, destroy?: any) {
    if (destroy === undefined) {
      destroy = true;
    }
    obj.destroy = destroy;
    if (obj.destroy && obj.$$orig) {
      // Must reset original values within the item, or we'll risk trying to store with missing
      // required fields, which will cause validation errors on backend
      for (let key in obj.$$orig) {
        if (key !== 'destroy') {
          const origValue = obj.$$orig[key];
          // Must avoid replacing array values, as the ones in $$orig are not the actual array values, and will cause
          // validation errors on backend if used!
          if (!Array.isArray(origValue)) {
            obj[key] = origValue;
          }
        }
      }
    }
  }

  deleteDestroy(obj: BaseModel) {
    delete obj.destroy;
  }


  getDestroy(obj: any) {
    return obj.destroy;
  }

  setCreate(obj: any, create?: boolean) {
    if (create === undefined) {
      create = true;
    }
    obj.create = create;
  }

  deleteCreate(obj: BaseModel) {
    delete obj.create;
  }

  getCreate(obj: any) {
    return obj.create;
  }

}
